import * as cr from "./_cr";
import * as hf from "./_hm";
import * as _ht from "./_ht";

import * as CdrC from "./_ccmCdrC";

import { useMdlz } from "./_csMdl";
import { a } from "./_cmABT";
import * as _cmFTH from "./_cmFTH";

export const useMdlDtmz = () => {

  const _sMdlz = useMdlz();

  const _show = async (pz: {
    dtmz: {
      crt: _ht.s,
      stt?: _ht.s,
      end?: _ht.s,
      hdys?: _ht.ls, // holliday
      dmds?: _ht.ls, // dimmed
    },
    onPrs: ( _date: _ht.s ) => void,
  }) => {

    let _hdys = await _cmFTH.loadLsAsync2({
      tgt: '_60r.load_601AsAsync',
    });
    _hdys = _hdys?.map((_dz: _ht.dz) => (_dz._icn));

    const _ls = [
      cr.c(CdrC.N, {
        key: -10,
        cz: {
          dtmz: {
            ... pz.dtmz,
            hdys: _hdys,
          },
          onPrs: ( _dtm: _ht.s ) => {
            pz.onPrs(_dtm);
            _sMdlz.set({
              bShow: false,
            })
          },
        }
      })
    ]

    _sMdlz.set({
      bShow: true,
      mdlClds: _ls,
    })

  }

  return {
    show: _show
  }

};
